<template>
    <div>
        <el-page-header @back="goBack" content="周抽活动奖品统计">
        </el-page-header>
        <el-card class="form-container" style="margin-top: 25px" shadow="never">
            <div style="margin-bottom: 10px;">
                <el-row>
                    <span class="demonstration">开奖日期：</span>
                    <el-date-picker
                        v-model="queryData.timeDate"
                        type="daterange"
                        :clearable="false"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd">
                    </el-date-picker>&emsp;&emsp;
                    <span class="demonstration">开奖状态：</span>
                    <el-select v-model="queryData.isOpen" filterable placeholder="请选择/输入">
                        <el-option
                            v-for="item in prizeStates"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                    <el-button class="sub-sub" type="primary" @click="queryActivitySummary">查询</el-button>
                </el-row>
                <h1>
                    <el-table border
                              :data="activityList"
                              :header-cell-style="{background:'#282828'}"
                              ref="filterTable"
                              max-height="820">
                        <el-table-column label="活动名称" prop="name"></el-table-column>
                        <el-table-column label="已发放券码数" prop="offerPrizeNumber"></el-table-column>
                        <el-table-column label="已发放用户数【券】" prop="offerUserNumber"></el-table-column>
                        <el-table-column label="券发放开始时间">
                            <template slot-scope="scope">
                                {{ formatDate(scope.row.ticketStartDt, "yyyy-MM-DD HH:mm:ss") }}
                            </template>
                        </el-table-column>
                        <el-table-column label="券发放结束时间" prop="ticketEndDt">
                            <template slot-scope="scope">
                                {{ formatDate(scope.row.ticketEndDt, "yyyy-MM-DD HH:mm:ss") }}
                            </template>
                        </el-table-column>
                        <el-table-column label="开奖时间" prop="prizeDt">
                            <template slot-scope="scope">
                                {{ formatDate(scope.row.prizeDt, "yyyy-MM-DD HH:mm:ss") }}
                            </template>
                        </el-table-column>
                        <el-table-column label="是否开奖" prop="isOpen">
                            <template slot-scope="scope">
                                <div v-if="scope.row.isOpen===true ">已开奖</div>
                                <div v-if="scope.row.isOpen===false">未开奖</div>
                            </template>
                        </el-table-column>
                        <el-table-column label="开奖号码数" prop="winPrizeNumber"></el-table-column>
                        <el-table-column label="开奖用户数" prop="winUserNumber"></el-table-column>

                    </el-table>
                    <el-row>
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="queryInfo.pagenum"
                            :page-sizes="[20,30,50]"
                            :page-size="queryInfo.pagesize"
                            layout="total, sizes, prev, pager, next"
                            :total="queryInfo.total">
                        </el-pagination>
                    </el-row>
                </h1>
            </div>
        </el-card>
    </div>
</template>

<script>
import {channelList, searchActivitySummary,} from "@/http/api";
import utils from '@/utils'

export default {
    name: "WeekActivitySummary",
    data() {
        return {
            activityList: [],
            channelList: [],
            subChannelList: [],
            subChannels: [],
            subChannelNames: [],
            queryData: {
                subChannels: [],
                timeDate: '',
                isOpen: null,
            },
            queryTrueData: {
                subChannels: [],
                timeDate: '',
                isOpen: null,
                startTime: '',
                endTime: '',
                order: 'ascending',
                prop: 'prize_dt'
            },
            queryInfo: {
                pagesize: 20,
                pagenum: 1,
                total: 0,
            },
            optionProps: {
                emitPath: false,
                multiple: true,
                value: 'subChannel',
                label: 'name',
                children: 'children',
            },
            prizeStates: [{id: null, name: '全部'},
                {id: 1, name: '已开奖'},
                {id: 0, name: '未开奖'}],

        }
    },
    methods: {
        formatDate: function (column, format) {
            return utils.DateUtil.formatDate(column, format)
        },
        handleSizeChange(newSize) {
            this.queryInfo.pagesize = newSize;
            this.queryActivitySummary();

        },
        goBack() {
            this.$router.push({path: '/ActivitySummary'})
        },
        handleCurrentChange(newPage) {
            this.queryInfo.pagenum = newPage;
            this.queryActivitySummary();
        },

        queryActivitySummary() {
            if (this.queryData.timeDate === null) {
                this.queryData.timeDate = ['', ''];
            }
            this.queryTrueData.startDt = this.queryData.timeDate[0];
            this.queryTrueData.endDt = this.queryData.timeDate[1];
            this.queryTrueData.isOpen = this.queryData.isOpen;
            this.queryTrueData.size=this.queryInfo.pagesize;
            this.queryTrueData.page=this.queryInfo.pagenum;
            console.log(this.queryTrueData)
            searchActivitySummary(this.queryTrueData).then(resp => {
                this.activityList = resp.data.info.list;
                this.queryInfo.total = resp.data.info.totalElements;
            })
        },
    },
    created() {
        this.queryData.timeDate = [utils.TodayUtil.getYesterday(), utils.TodayUtil.getNow()];
        this.queryActivitySummary();
        channelList().then(resp => {
            let _this = this;
            this.channelList = JSON.parse(JSON.stringify(resp.data.info)).map(channel => {
                if (channel.children) {
                    channel.children = channel.children.filter(sub => sub.state === 1)
                }
                return channel;
            }).filter(channel => channel.children && channel.children.length);
            this.channelList.forEach(function (channel) {
                _this.$set(channel, 'subChannel', channel.id);
                channel.children.forEach(function (sub) {
                    _this.subChannelList.push(sub);
                    _this.subChannels.push(sub.subChannel);
                })
            });
        });
    }
}
</script>

<style scoped>
</style>